import { z } from "zod";

export const giftCardPurchaseSchema = z
  .object({
    valueInEur: z
      .number()
      .min(50, "Najmanji iznos je 50 €.")
      .max(1000, "Najveći iznos je 1.000 €."),
    deliveryMode: z.enum(["recipient", "buyer"]).default("recipient"),
    isAnonymous: z.boolean().optional(),
    recipientEmail: z.string().trim().default(""),
    recipientName: z.string().max(100).optional(),
    personalMessage: z.string().max(500).optional(),
    purchaserEmail: z.string().trim().email("Unesi svoju email adresu."),
    purchaserName: z.string().max(100).optional(),
  })
  .superRefine((data, ctx) => {
    if (
      data.deliveryMode === "recipient" &&
      !z.string().email().safeParse(data.recipientEmail).success
    ) {
      ctx.addIssue({
        code: "custom",
        path: ["recipientEmail"],
        message: "Unesi ispravnu email adresu primaoca.",
      });
    }
  });

export type GiftCardPurchase = z.infer<typeof giftCardPurchaseSchema>;
export const GIFT_CARD_DRAFT_KEY = "gift-card-draft";

export function readGiftCardDraft(): GiftCardPurchase | null {
  try {
    const raw = sessionStorage.getItem(GIFT_CARD_DRAFT_KEY);
    const result = giftCardPurchaseSchema.safeParse(
      raw ? JSON.parse(raw) : null,
    );
    return result.success ? result.data : null;
  } catch {
    return null;
  }
}
